﻿(()=>{
 'use strict';
 const home='/pages/ceylon-cinnamon',optional='/products/ceylon-cinnamon-7200mg',automatic='/products/cinnamon-softgels-ceylon';
 const clean=p=>p.replace(/^\/es(?=\/|$)/,'').replace(/\/+$/,'')||'/';
 const path=clean(location.pathname),locale=/^\/es(?:\/|$)/.test(location.pathname)?'/es':'';
 const key='veruma-cinnamon-entry-page-v1';
 let entry=path;
 try{entry=sessionStorage.getItem(key)||path;sessionStorage.setItem(key,entry);}catch(_){}
 // Metabolae's exception routing preserves direct product entry, while campaign/landing
 // entry routes its main-product links to the subscription-only offer.
 const excluded=new Set([home,optional,automatic]);
 const fromHome=path===home;
 const automaticFlow=fromHome||!excluded.has(entry);
 function destination(url){
  const u=new URL(url,location.href);
  if(u.origin!==location.origin||clean(u.pathname)!==optional||!automaticFlow)return null;
  u.pathname=(/^\/es(?:\/|$)/.test(u.pathname)?'/es':locale)+automatic;
  return u;
 }
 // Redirect before the optional product selector renders when arriving through
 // the same landing-page flow that redirects on Metabolae.
 if(path===optional&&!excluded.has(entry)){
  const next=new URL(location.href);next.pathname=locale+automatic;location.replace(next.href);return;
 }
 function updateLinks(scope){
  scope.querySelectorAll('a[href]').forEach(a=>{try{const next=destination(a.href);if(next)a.href=next.pathname+next.search+next.hash;}catch(_){}});
 }
 function ready(){updateLinks(document);new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1){if(node.matches('a[href]')){try{const next=destination(node.href);if(next)node.href=next.pathname+next.search+next.hash;}catch(_){}}updateLinks(node);}}).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
 document.addEventListener('click',e=>{const a=e.target.closest('a[href]');if(!a)return;try{const next=destination(a.href);if(next)a.href=next.pathname+next.search+next.hash;}catch(_){}},true);
})();
